<template>
  <!-- 第二步：准备具备大小的dom容器 -->
  <div id="main"></div>
</template>

<script>
// 第一步：下载并引入echarts
import * as echarts from 'echarts';

export default {
  mounted() {
    // 第三步：基于准备好的dom，初始化echarts实例 echarts.init(dom容器)
    var myChart = echarts.init(document.getElementById('main'));
    // 第四步：指定配置项option
  let branch = 52, branchTotal = 128; //科数
    let branch2 = 40, branchTotal2 = 256; //科数
let species = 82, speciesTotal = 228 ; //种数

let option = {
  title: [
    {
      text: '正常百分比',
      textStyle: {
        fontSize: 14,
        color: '#FFFFFF'
      },
    /*   subtext: '正常百分比', */
      subtextStyle: {
        color: '#333',
        fontSize: 14,
        fontWeight: 'bold'
      },
      left: '20%',
      top: '65%',
      textAlign: 'center'
    },
    {
      text: '故障百分比',
      textStyle: {
        fontSize: 14,
        color: '#FFFFFF'
      },
      /* subtext: '总种数', */
      subtextStyle: {
        color: '#333',
        fontSize: 14,
        align: 'center',
        fontWeight: 'bold'
      },
      left: '50%',
      top: '65%',
      textAlign: 'center'
    },
    {
      text: '离线百分比',
      textStyle: {
        fontSize: 14,
        color: '#FFFFFF'
      },
      /* subtext: '总种数', */
      subtextStyle: {
        color: '#333',
        fontSize: 14,
        align: 'center',
        fontWeight: 'bold'
      },
      left: '80%',
      top: '65%',
      textAlign: 'center'
    }
  ],
  series: [
    {
      name: '正常百分比',
      type: 'pie',
      hoverAnimation: false,
      radius: ['20%', '25%'],
      center: ['20%', '50%'],
      label: {
        show: false
      },
      data: [
        {
          value: branch,
          /* name: '总科数', */
          label: {
            show: true,
            position: 'center',
            formatter: '{b|{b}}{d|{d}}%',
            rich: {
              b: {
                fontSize: 14,
                lineHeight: 30,
                color: '#333'
              },
              d: {
                fontSize: 24,
                color: '#333',
                fontWeight: 'bold'
              }
            },
            color: '#333'
          },
          itemStyle: {
            normal: {
              color: '#1890FF'
            }
          }
        },
        {
          value: branchTotal - branch,
          //不需要显示的数据，颜色设置成和背景一样
          itemStyle: {
            normal: {
              color: '#0000FF30'
            }
          }
        }
      ]
    },
    {
      name: '故障百分比',
      type: 'pie',
      hoverAnimation: false,
      radius: ['20%', '25%'],
      center: ['50%', '50%'],
      label: {
        show: false
      },
      data: [
        {
          value: branch2,
          /* name: '总科数', */
          label: {
            show: true,
            position: 'center',
         
            formatter: '{b|{b}}{d|{d}}%',
            rich: {
              b: {
                fontSize: 14,
                lineHeight: 30,
                color: '#333'
              },
              d: {
                fontSize: 24,
                color: '#333',
                fontWeight: 'bold'
              }
            },
            color: '#333'
          },
          
          itemStyle: {
            normal: {
              color: '#00FFFF'
            }
          }
        },
        {
          value: branchTotal2 - branch2,
          //不需要显示的数据，颜色设置成和背景一样
          itemStyle: {
            normal: {
              color: '#0000FF30'
            }
          }
        }
      ]
    },
    {
      name: '离线百分比',
      type: 'pie',
      hoverAnimation: false,
      radius: ['20%', '25%'],
      center: ['80%', '50%'],
      label: {
        show: false
      },
      data: [
        {
          value: species, //需要显示的数据
          /* name: '总种数', */
          label: {
            show: true,
            position: 'center',
            formatter: '{b|{b}}{d|{d}}%',
            rich: {
              b: {
                fontSize: 14,
                lineHeight: 30,
                color: '#333'
              },
              d: {
                fontSize: 24,
                color: '#333',
                fontWeight: 'bold'
              }
            },
            color: '#333'
          },
          itemStyle: {
            normal: {
              color: '#FAFA14'
            }
          }
        },
        {
          value: speciesTotal - species,
          //不需要显示的数据，颜色设置成和背景一样
          itemStyle: {
            normal: {
              color: '#0000FF30'
            }
          }
        }
      ]
    }
  ]
};

  
    // 第五步：绘制图表，把配置项给实例对象
    myChart.setOption(option);
  }
}
</script>

<style>
/* 第二步 */
#main {
  width: 500px;
  height: 400px;
  margin: auto; 
}
</style>
